{
  "_comment": "NC #819 — gedeelde voornaam-variantentabel (canoniek eerst). Gelezen door src/utils/dutchNameNormalizer.ts en shared/archiveNameMatching.js. Staat een variant in twee rijen, dan wint de laatste.",
  "varianten": [
    ["johannes", "jan", "janus", "jo", "joop", "hans", "hannes", "joannes", "johan"],
    ["petrus", "pieter", "piet", "peter", "pete", "pier"],
    ["nicolaas", "klaas", "claas", "nico", "niels", "niek", "klaes", "claus"],
    ["margaretha", "grietje", "griet", "margriet", "greta", "meta", "margareta", "gretha"],
    ["cornelis", "cees", "cor", "kees", "neel", "nelis", "cornelius"],
    ["hendrikus", "hendrik", "henk", "hein", "rik", "harry", "driek", "henricus"],
    ["maria", "marie", "maartje", "ria", "mies", "maaike", "marian", "mary"],
    ["jacobus", "jaap", "koos", "co", "cobus", "jacob", "jakob"],
    ["adrianus", "adriaan", "dries", "arie", "arend", "ari"],
    ["elisabeth", "lies", "lisa", "bets", "betty", "elise", "eliza", "betje", "lisbeth"],
    ["wilhelmina", "wil", "willy", "mien", "mina", "mientje", "wilma"],
    ["wilhelmus", "willem", "wim", "pim"],
    ["franciscus", "frank", "franz", "fons", "frits", "franchois", "frans"],
    ["gerardus", "gerard", "gerrit", "geert", "gert", "ger"],
    ["theodorus", "theo", "teus", "ties", "dirk"],
    ["antonius", "anton", "antoon", "toon", "ton", "tonie"],
    ["lambertus", "lambert", "bert", "bertus"],
    ["hubertus", "hubert", "hub", "hubrecht"],
    ["bartholomeus", "bart", "bartel", "mees"],
    ["christina", "chris", "stien", "tina", "stientje", "christien"],
    ["catharina", "trijntje", "trien", "kaatje", "catrien", "katrien", "cato"],
    ["geertruida", "truus", "geertje", "truida", "trui"],
    ["hendrika", "hennie", "heintje", "rika"],
    ["johanna", "janna", "jans", "jantje", "joke", "jopie", "hanneke", "joanna"],
    ["pieternella", "nella", "nelly", "pietje", "neeltje", "neel"],
    ["aaltje", "aaltien", "ale"],
    ["albertus", "albert", "alb", "bertus"],
    ["bernardus", "bernard", "berend", "ben", "barend"],
    ["christianus", "christiaan", "chris"],
    ["david", "davit"],
    ["frederik", "fred", "frits", "freek"],
    ["gijsbertus", "gijs", "gijsbert", "gilbert"],
    ["hermanus", "herman", "man", "manus"],
    ["isaak", "izaak", "isaac"],
    ["laurentius", "laurens", "lars"],
    ["martinus", "marten", "maarten", "tinus"],
    ["philippus", "filip", "flip"],
    ["reinerus", "reinier", "reinder", "rein"],
    ["simon", "siem", "simeon"],
    ["stephanus", "steven", "stefan", "stef"],
    ["thomas", "tom", "tomas"],
    ["matthijs", "mathijs", "matthias", "mathias", "matthys", "thijs"],
    ["anna", "anneke", "annie", "annet", "annigje"],
    ["cornelia", "corrie", "nelia", "neeltje"],
    ["sophia", "sofie", "fietje", "fie"],
    ["theodora", "thea", "dora", "doortje"],
    ["antonia", "tonnie", "tonia", "toontje"],
    ["frederika", "frida", "rika", "freekje"],
    ["jacoba", "jacomina", "koosje", "mina"],
    ["susanna", "sanne", "sus", "sanna"],
    ["helena", "lena", "leen", "heleen", "helene"],
    ["clasina", "sina", "klasien", "klaasje"],
    ["willempje", "willemijntje", "willie", "wimpje"],
    ["abraham", "abram", "bram"],
    ["adam"]
  ]
}
